const baseServiceOptions = [
  'Army',
  'Navy',
  'AirForce',
  'MarineCorps',
  'CoastGuard',
];

export const militaryServiceOptions = [
  ...baseServiceOptions,
  'ArmyNationalGuard',
  'AirNationalGuard',
];

export const militaryServiceOptionsSF852013 = [
  ...baseServiceOptions,
  'NationalGuard',
  'MerchantMarine',
];

export const militaryServiceOptionsPvq = [
  'AirNationalGuard',
  'ArmyNationalGuard',
  'NationalOceanicAtmosphericAdministration',
  'AirForce',
  'Army',
  'CoastGuard',
  'MarineCorps',
  'Navy',
  'PublicHealthService',
  'SpaceForce',
];
